import PageLoadedQueue from "./PageLoadedQueue";
import {retyping} from "../Plugins/Retyping";

PageLoadedQueue.addFunction(() => {
    const searchInputs = document.querySelectorAll('input[name="term"][data-search-hints]') as NodeListOf<HTMLInputElement>

    if (!searchInputs.length) {
        return;
    }

    searchInputs.forEach(searchInput => {
        retyping(searchInput, searchInput.dataset.searchHints, 'placeholder', searchInput.dataset.searchPrefix);
    });
});
